import { defineField, defineType } from "sanity";

export const programModuleItemType = defineType({
  type: "object",
  name: "programModuleItem",
  title: "Program Module Item",
  groups: [
    { name: "meta", title: "Meta" },
    { name: "content", title: "Content" }
  ],
  fields: [
    defineField({
      name: "title",
      type: "string",
      title: "Title",
      validation: (Rule) => Rule.required(),
      group: "meta"
    }),
    defineField({
      name: "taskReference",
      type: "string",
      title: "Task Reference",
      description: "Enter the task reference, Group ID or a Task ID",
      group: "meta",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "description",
      type: "string",
      group: "content"
    }),
    defineField({
      name: "image",
      type: "image",
      title: "Image",
      group: "content"
    }),
    defineField({
      name: "relatedData",
      type: "array",
      title: "Module Related Data",
      of: [
        {
          type: "programRelatedData"
        }
      ],
      group: "content"
    })
  ],
  preview: {
    select: {
      title: "title",
      description: "description",
      image: "image",
      related: "relatedData",
      taskReference: "taskReference"
    },
    prepare(selection) {
      const {
        title,
        description,
        image,
        related = [],
        taskReference
      } = selection as {
        title?: string;
        description?: string;
        image?: React.ReactNode;
        related?: Array<{ key: string }>;
        taskReference?: string;
      };
      const relatedAsEmoji = related.map((item) => {
        switch (item.key) {
          case "videoId":
            return "🎥";
          case "typeformQuestionnaireId":
            return "📝";
          default:
            return "🤷‍♂️";
        }
      });
      const emojiString =
        relatedAsEmoji.length > 0 ? `${relatedAsEmoji.join(",")} | ` : "";
      return {
        title: title,
        subtitle: `${taskReference ?? ""} | ${emojiString}${description ?? ""}`,
        media: image
      };
    }
  }
});
